import React from 'react';
import AuthLayoutCommon from '@lib/layouts/AuthLayout/AuthLayout';
import useTechnicalPause from '@lib/hooks/useTechnicalPause';
import TechnicalPauseTracker from '@lib/components/TechnicalPauseTracker/TechnicalPauseTracker';
import CircleLoader from '@lib/components/CircleLoader/CircleLoader';
import { APP_URLS } from 'constants/urls';

function AuthLayout(): React.ReactElement {
  const { activeTechnicalPause, fetched: technicalPauseFetched } =
    useTechnicalPause();
  const technicalPauseEndDate = activeTechnicalPause?.endAt;
  if (!technicalPauseFetched) {
    return <CircleLoader />;
  }
  if (technicalPauseEndDate) {
    return (
      <TechnicalPauseTracker technicalPauseEndDate={technicalPauseEndDate} />
    );
  }
  return (
    <AuthLayoutCommon
      finishRegistrationUrl={APP_URLS.setup.finishRegistration.path}
      forgotPasswordUrl={APP_URLS.auth.forgotPassword.path}
      loginUrl={APP_URLS.auth.login.path}
      logoUrl={APP_URLS.root.getPathWithQuery()}
    />
  );
}

export default AuthLayout;
